import '../../css/FormTemplate.css'

const FormSubmitButton = (props:{text:string, disabled:boolean}) => {

    return (
        <div className='form-template-div-button'>
            <button type="submit" className="submit-form-btn" disabled={props.disabled}>
                {props.text}
            </button>
        </div>
    );
};

export default FormSubmitButton;